/**
 * B*Label Cart Drawer Helper Functions
 * Include this before your main product-card-hover.js script.
 */

// Check if we're in the B*Label theme
const isBLabelTheme = document.querySelector('.site-header__logo-image[src*="B*Label"]') !== null;

// Make sure we don't define functions twice
if (typeof window.openCartDrawer !== 'function') {
  // Open the cart drawer for B*Label theme
  window.openCartDrawer = function() {
    // Try each possible selector for B*Label cart drawer
    const cartToggle = document.querySelector(
      '.cart-link, ' +
      '.cart-drawer-trigger, ' +
      'a[href="/cart"], ' +
      '[data-action="open-drawer"], ' +
      '[data-cart-drawer-toggle], ' +
      '[aria-controls="cart-drawer"], ' +
      '[aria-controls="CartDrawer"]'
    );
    
    if (cartToggle) {
      cartToggle.click();
      return true;
    }
    
    // If no toggle found, try another approach
    const miniCart = document.querySelector('.mini-cart, #mini-cart, .cart-drawer, #cart-drawer');
    if (miniCart) {
      miniCart.classList.add('is-active', 'is-visible', 'drawer--is-open');
      document.body.classList.add('drawer-open');
      return true;
    }
    
    return false;
  };
}

// Update cart count for B*Label
function updateBLabelCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartCount = cart.item_count;
      
      // Update all possible cart count elements
      document.querySelectorAll('.cart-count, .cart-count-bubble, .site-header__cart-count').forEach(counter => {
        if (counter.tagName === 'SPAN') {
          counter.textContent = cartCount;
        } else {
          const span = counter.querySelector('span');
          if (span) {
            span.textContent = cartCount;
          }
        }
        
        if (cartCount > 0) {
          counter.style.display = '';
        } else {
          counter.style.display = 'none';
        }
      });
    })
    .catch(error => console.error('Error updating cart count:', error));
}

// B*Label specific cart drawer opener (more reliable)
function openBLabelCartDrawer() {
  // Try direct DOM access to cart drawer
  const cartDrawer = document.querySelector('#CartDrawer, #cart-drawer, .cart-drawer, .mini-cart');
  
  if (cartDrawer) {
    // Apply all possible class combinations for different B*Label implementations
    cartDrawer.classList.add('is-active', 'active', 'is-visible', 'visible', 'drawer--is-open', 'drawer-open');
    document.body.classList.add('js-drawer-open', 'drawer-open');
    
    // Also try to trigger the click event on cart toggle
    window.openCartDrawer();
    return true;
  }
  
  // If direct access failed, try the standard approach
  return window.openCartDrawer();
}

// Force cart drawer to open via direct attribute manipulation
function forceOpenCartDrawer() {
  // First try B*Label specific approach
  if (openBLabelCartDrawer()) {
    return;
  }
  
  // If B*Label approach failed, try generic approaches
  const cartDrawers = [
    document.querySelector('.cart-drawer'),
    document.querySelector('#CartDrawer'),
    document.querySelector('[data-section-id="cart-drawer"]'),
    document.querySelector('.mini-cart')
  ];
  
  for (const drawer of cartDrawers) {
    if (drawer) {
      // Try all possible combinations to open the drawer
      drawer.classList.add('is-active', 'active', 'is-visible', 'visible', 'drawer--is-open', 'drawer-open');
      drawer.setAttribute('open', '');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('js-drawer-open', 'drawer-open');
      
      // Also try using the open method if it's a custom element
      if (typeof drawer.open === 'function') {
        drawer.open();
      }
      
      return;
    }
  }
  
  // Last resort - use the cart link
  const cartLink = document.querySelector('a[href="/cart"]');
  if (cartLink) {
    // Create and dispatch a custom click event
    const clickEvent = new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window
    });
    cartLink.dispatchEvent(clickEvent);
  }
}

// Override the fetch API to intercept cart/add requests
const originalFetch = window.fetch;
window.fetch = function() {
  const url = arguments[0];
  const options = arguments[1];
  
  // Call the original fetch
  return originalFetch.apply(this, arguments)
    .then(function(response) {
      // Clone the response so it can be used multiple times
      const clone = response.clone();
      
      // Check if this is a cart/add request
      if (url && typeof url === 'string' && url.includes('/cart/add') && options && options.method === 'POST') {
        // Wait a short time before opening the cart drawer
        setTimeout(function() {
          // Try to force open the cart drawer
          forceOpenCartDrawer();
          // Update cart count
          updateBLabelCartCount();
        }, 300);
      }
      
      // Return the original response
      return response;
    });
};

// Initialize event listeners when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  // Listen for custom cart update events (if any)
  document.addEventListener('cart:update', function(event) {
    // Try to open cart drawer
    forceOpenCartDrawer();
  });
  
  // If this is the cart page, update the cart count
  if (window.location.pathname.includes('/cart')) {
    updateBLabelCartCount();
  }
});